import React from "react"
import { renderToString } from "react-dom/server"
import { MarkdownContent as MarkdownContainer } from "@alexanderathoodly/ui-library"
import { ThumborImage } from "react-thumbor-img"
import { ThumborConfigured } from "../helpers/thumbor"

interface MarkdownContentProps {
    content: string
    className?: string
}

const thumborPlugin = {
    type: "output",
    regex: new RegExp(`<img(?:.*?)src="(.*?)"(?:.*?)>`, "g"),
    replace: (s: string, url: string): string => {
        const result = renderToString(
            <ThumborConfigured>
                <ThumborImage src={url} width={1070} generateSrcSet={false} />
            </ThumborConfigured>
        )
        return result
    },
}

const MarkdownContent = ({ content, className }: MarkdownContentProps): JSX.Element => {
    return (
        <MarkdownContainer
            className={className}
            content={content}
            converterOptions={{ extensions: [thumborPlugin], tables: true, backslashEscapesHTMLTags: true }}
        />
    )
}

export default MarkdownContent
